<template>
  <div class="device-ct">
    <PullDown v-if="!hidePullDown" style="margin-top: 0;"></PullDown>
    <div class="nav">
      <div class="module-title">
        医学图像处理教学系统
      </div>

      <div class="ct-content">
        <div class="single-col-card">
          <!-- 文字描述 -->
          <div class="text-wrap">
            <p class="text-content">{{ p[0] }}</p>
          </div>

          <!-- 桌面端右侧大图 -->
          <div class="main-banner imgLimit hidden-xs-only">
            <img :src="img[0]" alt="课程主图" class="banner-img" />
            <div class="banner-glow"></div>
          </div>

          <!-- GIF动图区域 -->
          <div class="main-banner gifLimit">
            <img :src="img[2]" alt="操作演示动图" class="banner-img" />
            <div class="banner-glow"></div>
          </div>

          <!-- 多图缩略组件 -->
          <ImgCol :imgList="img.slice(3)" class="hidden-xs-only"></ImgCol>
        </div>

        <!-- 参考资料区块，统一标准卡片样式 -->
        <div class="standard-block">
            <div class="refer-text">
              参考资料：《医学影像图像处理实践教程》   主编：邱建峰 聂生动   出版社：清华大学出版社   标准书号：ISBN  978-7-302-32458-4
            </div>
            <div class="refer-text" style="margin-top:12px;">
              参考资料：《医学影像成像理论》   主编：李真林 雷子乔   标准书号：ISBN  978-7-117-22876-3 等
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgCol from "@/components/imgCol.vue"
import PullDown from "@/components/home/pullDown.vue"
export default {
  props: {
    hidePullDown: {
      type: Boolean,
      default: false // 默认显示
    }
  },
  name: "CourseImageProcess",
  components: {
    ImgCol,
    PullDown
  },
  data() {
    return {
      wWidth: window.innerWidth,
      p: [
        "本系统以《医学图像处理》的教学内容为基础，综合医、理、工等多学科知识，通过一站式实践教程的方式，突破教学过程中交叉学科知识点晦涩难懂的瓶颈。系统包括11个实验单元，涵盖医学图像文件格式、医学图像计算、医学图像变换、医学图像增强、医学图像形态学运算、医学图像分割、医学图像重建和可视化等教学内容，学生可在虚拟环境中动手操作图像处理全流程，将抽象的数学算法与临床影像实践紧密结合，有效提升医学图像处理与分析的实操能力，为智能影像诊断奠定技术基础。"
      ],
      img: [
        require("@/assets/course_big.png"),
        require("@/assets/course_c.png"),
        require("@/assets/course_move.gif"),
        require("@/assets/course1.png"),
        require("@/assets/course2.png"),
        require("@/assets/course3.png")
      ],
      showMove: true,
      showStatic: false
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.wWidth = window.innerWidth;
    },
    // unShow(){
    //     this.showMove = !this.showMove
    //     this.showStatic = !this.showStatic
    // }
  }
}
</script>

<style lang="scss" scoped>
.device-ct {
  width: 100%;
  padding: 1rem;
  margin-top: 80px;
  background: linear-gradient(180deg, #f0f6ff 0%, #ffffff 100%);
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  @media (max-width: 767px) {
    margin-top: 60px;
    padding: 0.5rem;
  }

  .nav {
    width: 60%;
    margin: 0 auto;
    border: none;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    box-shadow: 0 20px 60px rgba(37, 75, 156, 0.10),
                0 8px 24px rgba(37, 75, 156, 0.06);
    transition: all 0.3s ease;
    overflow: hidden;
    margin-top: 20px;

    @media (max-width: 1024px) {
      width: 80%;
    }
    @media (max-width: 767px) {
      width: 100%;
      border-radius: 16px;
      box-shadow: 0 12px 40px rgba(37, 75, 156, 0.08);
    }

    &:hover {
      box-shadow: 0 24px 72px rgba(37, 75, 156, 0.14);
    }
  }

  .module-title {
    padding: 2.5rem 2rem 1.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a365d;
    text-align: center;
    letter-spacing: 0.04em;
    position: relative;
    background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;

    @media (max-width: 767px) {
      font-size: 1.25rem;
      padding: 1.5rem 1rem 1rem;
      gap: 8px;
    }

    &::after {
      content: "";
      width: 100px;
      height: 4px;
      background: linear-gradient(90deg, #2563eb, #60a5fa, #2563eb);
      border-radius: 4px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .ct-content {
    padding: 2.5rem 3rem 3rem;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 48px;

    @media (max-width: 1024px) {
      padding: 2rem 2rem 2.5rem;
      gap: 36px;
    }
    @media (max-width: 767px) {
      padding: 1.5rem 1rem 1.5rem;
      gap: 28px;
    }
  }

  .single-col-card {
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;
    width: 100%;
    margin: auto;
  }

  // 全局统一文字样式（全系列页面共用）
  .text-content {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 0.95rem;
    line-height: 2;
    color: #1e293b;
    text-align: justify;
    letter-spacing: 0.01em;
    position: relative;
    padding-left: 1rem;
    border-left: 3px solid transparent;

    @media (max-width: 767px) {
      font-size: 0.85rem;
      line-height: 1.85;
      padding-left: 0.75rem;
    }

    &:first-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(59, 130, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }

    &:last-of-type {
      margin-bottom: 2rem;
      border-left-color: #3b82f6;
      background: linear-gradient(90deg, rgba(139, 92, 246, 0.04) 0%, transparent 100%);
      padding: 0.75rem 1rem 0.75rem 1.5rem;
      border-radius: 0 8px 8px 0;

      @media (max-width: 767px) {
        padding: 0.5rem 0.75rem 0.5rem 1rem;
      }
    }
  }

  // 图片通用大图样式
.imgLimit.main-banner {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  height: auto;
  width: 100%;
  max-width: 834px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: auto;
    display: block;
    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
    object-fit: contain;
    object-position: center;
  }
}
  .gifLimit.main-banner {
    position: relative;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(26, 75, 140, 0.12);
    max-width: 834px;
    width: 100%;
    margin: 0 auto;

    @media only screen and (max-width: 767px) {
      max-width: 100%;
    }
  }
  .banner-img {
    width: 100%;
    display: block;
    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .main-banner:hover .banner-img {
    transform: scale(1.035);
  }
  .banner-glow {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 45%;
    background: linear-gradient(to top, rgba(26, 75, 140, 0.22), transparent);
    pointer-events: none;
  }

  // 参考资料卡片统一规范
  .book-card {
    background-color: #f0f7ff;
    border-radius: 12px;
    padding: 32px 24px;
    text-align: left;
  }
  .standard-card {
    border-left: 5px solid #2563AF;
    transition: all 0.3s ease;
  }
  .standard-card:hover {
    border-left-color: #67a6dc;
    box-shadow: 0 0 12px rgba(37, 99, 175, 0.15);
  }
  .refer-text {
    font-size: 14px;
    color: #555;
    line-height: 1.8;
    text-align: left;
  }

  // ImgCol穿透样式统一
  :deep(.imgCom) {
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    margin-bottom: 14px;
  }
  :deep(.imgCom:hover) {
    transform: translateY(-3px);
    box-shadow: 0 10px 26px rgba(10, 40, 70, 0.12);
  }
  :deep(.imgCom img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.4s ease;
  }
  :deep(.imgCom:hover img) {
    transform: scale(1.04);
  }
}

// 暗色模式完整适配
@media (prefers-color-scheme: dark) {
  .device-ct {
    background: linear-gradient(180deg, #0f1724 0%, #0a0f1a 100%);

    .nav {
      background: rgba(20, 30, 50, 0.92);
      backdrop-filter: blur(12px);
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);

      .module-title {
        color: #93bbfc;
        background: linear-gradient(135deg, #0f1a2e 0%, #162035 100%);
        &::after {
          background: linear-gradient(90deg, #1d4ed8, #60a5fa, #1d4ed8);
        }
      }

      .ct-content {
        background: #0f1a2e;

        .single-col-card {
          background: #142033;
        }
        .text-content {
          color: #c8d6e8;
          &:first-of-type {
            background: linear-gradient(90deg, rgba(59, 130, 246, 0.08) 0%, transparent 100%);
          }
          &:last-of-type {
            background: linear-gradient(90deg, rgba(139, 92, 246, 0.08) 0%, transparent 100%);
          }
        }
        .book-card {
          background: rgba(37, 99, 175, 0.12);
        }
        .refer-text {
          color: #b0c4de;
        }
        :deep(.imgCom) {
          background: #142033;
        }
      }
    }
  }
}

// 全局导航统一穿透样式
:deep .global-nav[data-v-5e75b752]{
    background: none;
    border: none;
    box-shadow: none;
    padding: 0 0;
    width: 100%;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
}
:deep .global-nav .nav-item .nav-title.active[data-v-5e75b752]:hover {
  color: #0f3059;
  background: transparent;
}
</style>